import { render, staticRenderFns } from "./FeaturedFlight.vue?vue&type=template&id=3644d944&"
import script from "./FeaturedFlight.vue?vue&type=script&lang=js&"
export * from "./FeaturedFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports